@import '../../theme/colors';

.collapsibleSidebar {
  position: relative;

  &.expanded {
    width: 50px;
  }

  .collapseButton {
    position: absolute;
    top: 2px;
    right: -13px;
    border-radius: 20px;
    background-color: $white;
    width: 26px;
    height: 26px;
    color: #000;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;

    .arrowLeft {
      font-size: 29px;
      color: $oceanBlue;
    }

    .menu {
      font-size: 18px;
      color: $activeMenuIcon;
    }
  }

  .collapseButton:hover {
    background-color: $hoverBlue;

    .arrowLeft {
      color: $white;
    }

    .menu {
      color: $white;
    }
  }

  .collapseButton:active {
    background-color: $white;

    .arrowLeft {
      color: $oceanBlue;
    }

    .menu {
      color: $activeMenuIcon;
    }
  }
}
